import styled from "styled-components";
import { device } from "../../services";
import { WhiteContainer } from "../../components";

export const LoginPageContainer = styled(WhiteContainer)`
  padding: 80px 106px;
  width: 100%;

  max-width: 678px;

  text-align: center;

  @media screen and ${device.tablet} {
    padding: 80px 64px;
  }

  @media screen and ${device.mobile} {
    padding: 64px 32px;
  }
`;

export const ChildrenWrapper = styled.div`
  max-width: 329px;
  width: 100%;
`;
